import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as moment from 'moment';
import webServices from '../services/webServices';
import whiteRose from '../assets/images/rose.svg';
import whiteFlowser from '../assets/images/lovrican-white.svg';
import whiteLike from '../assets/images/hear-white.svg';
import { pageTitle } from '../redux/actions/home.actions';
import Spinner from '../components/general/spinner';

const BillingDetailsPage = () => {
  const dispatch = useDispatch();
  const [invoice, setInvoice] = useState([]);
  const [isSpinner, setIsSpinner] = useState(true);

  useEffect(async () => {
    dispatch(pageTitle('Payment History'));

    const resp = await webServices.getOrderDetails();
    if (resp && resp.success) {
      setInvoice(resp.data);
      setTimeout(() => setIsSpinner(false), 400);
    }
  }, []);
  return (
    <>
      <div className="full-page planWrapper">
        <div className="container">
          {isSpinner ? (
            <Spinner active={isSpinner} />
          ) : (
            <>
              <div className="paymentDetailsWrapper">
                <div className="mid-container panConatiner">
                  <div className="row">
                    <div className="col-12">
                      <div className="listWrapper">
                        {invoice.length ?
                          invoice.map((value) => <PurchaseHistoryDetailsRowComponent purchaseHistory={value} />) :
                          <div className="d-flex justify-content-center"><h3>No record found!</h3></div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const PurchaseHistoryDetailsRowComponent = ({ purchaseHistory }) => {
  const { id, planId, orderId, purchaseQuantity, createdAt: purchasedAt, amount: planAmount, payment_gateway: paymentGateway, plan: { name: planName, plan_type: planType } } = purchaseHistory;
  const planColorsArr = {
    1: 'orange',
    2: 'green',
    3: 'rose',
  };
  const planImgArr = {
    1: whiteRose,
    2: whiteLike,
  };
  const planColor = planColorsArr[planId] ?? 'rose';
  const planImage = planImgArr[planId] ?? whiteFlowser;
  let total = planAmount;
  let purchasedPlanName = planName;
  if (planType === '1') {
    purchasedPlanName = `${purchasedPlanName} ${purchaseQuantity > 1 ? 'Roses' : 'Rose'}`;
  } else if (planType === '2') {
    purchasedPlanName = `${purchaseQuantity} ${purchaseQuantity > 1 ? 'Likes' : 'Like'}`;
  }

  if (paymentGateway === 1) {
    const paymentDetails = purchaseHistory.orderDetails
      ? JSON.parse(purchaseHistory.orderDetails)
      : '';

    total = paymentDetails && paymentDetails?.purchase_units ? (paymentDetails?.purchase_units[0]?.payments?.captures[0]?.amount?.purchaseHistory) : 0;
  }

  return (
    <>
      <div
        key={id}
        className={`card ${planColor}`}
      >
        <div className="card-header">
          <div className="icon">
            <img
              src={planImage}
              className="img-fluid"
              alt="Lovrican rose"
            />
          </div>
        </div>
        <div className="card-body">
          <div className="planName">{purchasedPlanName}</div>
          <div className="date">{moment(purchasedAt).format('MMM DD, YYYY')}</div>
          <div className="row">
            <div className="col-md-6">
              <div className="card-details">
                <p>
                  Order ID <br />
                  <span>{orderId}</span>
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card-details total">
                <p>
                  <span>Total $</span>
                </p>
                <div className="price">${total}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingDetailsPage;
